import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

export class TableDataSource extends DataSource<any> {
    
    constructor(private subject: BehaviorSubject<any[]>){
        super();
    }

    connect(): Observable<any[]> {
        return this.subject.asObservable();
    }

    disconnect() {}
}
    


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/table-data-source.ts